<template>
  <div>
    <nav>
      <b-pagination
        :total-rows="getRowCount(items)"
        :per-page="perPage"
        v-model="currentPage"
        prev-text="Anterior"
        next-text="Próxima"
        hide-goto-end-buttons
      />
    </nav>
    <b-table
      :busy="isBusy"
      :items="items"
      :fields="fields"
      striped
      bordered
      hover
      :current-page="currentPage"
      :per-page="perPage"
    >
      <div slot="table-busy" class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Carregando...</strong>
      </div>
      <div slot="Total" slot-scope="data">R$ {{data.item.Total}}</div>
      <div slot="ValorMedio" slot-scope="data">R$ {{data.item.ValorMedio}}</div>
      <template slot="HEAD_Total">Valor vendido</template>
      <template slot="FOOT_Total">R${{Number(total.toFixed(2)).toLocaleString('pt-BR')}}</template>
      <template slot="FOOT_Qtd">{{Number(qtd).toLocaleString('pt-BR')}}</template>
      <template slot="FOOT_ValorMedio">R${{Number(total/qtd).toFixed(2).toLocaleString('pt-BR')}}</template>
      <template slot="FOOT_Forma">Total</template>
    </b-table>
  </div>
</template>

<script>
import axios from "axios";
import * as config from "@/config.json";
import moment from "moment";

export default {
  data: function() {
    return {
      isBusy: true,
      items: [],
      fields: [
        "Forma",
        "Total",
        "Qtd",
        {
          key: "ValorMedio",
          label: "Ticket"
        }
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      total: 0,
      qtd: 0,
      ticket: 0
    };
  },
  props: ["datainicial", "datafinal"],
  watch: {
    datainicial(newValue, oldValue) {
      if (newValue != oldValue) this.fillData();
    },
    datafinal(newValue, oldValue) {
      if (newValue != oldValue) this.fillData();
    }
  },
  methods: {
    getRowCount(items) {
      if (items) return items.length;
      else return 0;
    },
    fillData() {
      var inicio = moment(this.datainicial).format("YYYY-MM-DD");
      var fim = moment(this.datafinal).format("YYYY-MM-DD");

      this.total = 0;
      this.qtd = 0;
      this.ticket = 0;
      this.items = [];

      axios
        .get(
          `${
            config.default.servidor
          }/gerencial/retorna-formas-de-recebimento/${localStorage
            .getItem("enterprise_id")
            .toString()}/${inicio}/${fim}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.data.data) {
            var resposta = response.data.data;
            for (let i = 0; i < resposta.length; i++) {
              const e = resposta[i];
              let total = e.Total;
              this.items.push({
                Forma: e.Forma,
                Total: `${Number(total)
                  .toLocaleString("pt-BR")
                  .toString()}`,
                Qtd: Number(parseFloat(e.Qtd)).toLocaleString("pt-BR"),
                ValorMedio: Number(
                  parseFloat(e.ValorMedio)
                ).toLocaleString("pt-BR")
              });
            }
          } else this.items = [];
          for (let i = 0; i < resposta.length; i++) {
            const e = resposta[i];
            this.total = this.total + parseFloat(e.Total);
            this.qtd = this.qtd + parseFloat(e.Qtd);
            this.ticket = this.ticket + parseFloat(e.ValorMedio);
          }
          this.isBusy = false;
        });
    }
  },
  mounted() {
    this.fillData();
  }
};
</script>
